import { format, isSameDay } from "date-fns";
import { toZonedTime } from "date-fns-tz";

export default function formatPeriod(
  obj: {
    startTime: string | null;
    endTime: string | null;
  },
  tzName: string,
) {
  if (!obj.startTime) {
    // Only quests can lack a start; it means they've always existed.
    if (!obj.endTime) return "Always on";
    const end = toZonedTime(obj.endTime, tzName);
    const endYear = end.getFullYear() === toZonedTime(new Date(), tzName).getFullYear();
    return format(
      end,
      `'${new Date(obj.endTime) > new Date() ? "Ends" : "Ended"}' do MMM${endYear ? "" : " yyyy"} 'at' HH:mm`,
    );
  }
  // Get dates in the venue's timezone (date-fns)
  const start = toZonedTime(obj.startTime, tzName);
  const end = obj.endTime ? toZonedTime(obj.endTime, tzName) : null;

  const isStartThisYear = start.getFullYear() === toZonedTime(new Date(), tzName).getFullYear();
  const isEndThisYear = end && end.getFullYear() === toZonedTime(new Date(), tzName).getFullYear();

  const startsInFuture = new Date(obj.startTime) > new Date();
  const endsInFuture = obj.endTime && new Date(obj.endTime) > new Date();

  if (end && isSameDay(start, end)) {
    if (isStartThisYear) {
      return `${format(start, "do MMM")}, ${format(start, "HH:mm")} – ${format(end, "HH:mm")}`;
    } else {
      return `${format(start, "do MMM yyyy")} ${format(start, "HH:mm")} – ${format(end, "HH:mm")}`;
    }
  } else {
    if (!obj.endTime || startsInFuture) {
      return format(
        start,
        `'${!startsInFuture ? "Starts" : "Started"}' do MMM ${
          isStartThisYear ? "" : " yyyy"
        } 'at' HH:mm`,
      );
    } else {
      return format(
        end!,
        `'${endsInFuture ? "Ends" : "Ended"}' do MMM${isEndThisYear ? "" : " yyyy"} 'at' HH:mm`,
      );
    }
  }
}
